import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Button, Col, Form, Modal, Row, Spinner } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import dayjs from 'dayjs';
import Swal from 'sweetalert2';

import { FILE_EXPORTS_GENERATE_REPORTS } from 'lib/networking/endpoints';
import { ReportType } from 'lib/enums/ReportGeneratrionEnums';
import SwalDialog from 'lib/utils/toast';
import usePost from 'lib/hooks/usePost';

const DATE_FORMAT = 'YYYY-MM-DD';

function SupportTicketReportExportModal({ onHide }) {
  const [startDate, setStartDate] = useState(dayjs().subtract(2, 'week').toDate());
  const [endDate, setEndDate] = useState(dayjs().toDate());

  const { postData: generateReport, loading } = usePost(
    FILE_EXPORTS_GENERATE_REPORTS,
    () => {
      Swal.fire({
        icon: 'success',
        html: `
        <div>
          The export csv file will be generated in a while.
          You can download the generated file from\n
          <a
            href="/file-exports"
            rel="noopener noreferrer"
            target="_blank"
          >
            File Exports Page
          </a>
        </div>`,
        title: 'Success',
        position: 'center',
      }).then(() => {
        onHide();
      });
    },
    error =>
      Swal.fire({
        icon: 'error',
        text: `An error occurred while generating the report: ${error?.response?.data?.message}`,
        title: 'Error',
      }),
  );

  const handleExport = () => {
    if (dayjs(startDate).isAfter(dayjs(endDate))) {
      SwalDialog(
        'error',
        '"From" date cannot be later than the "To" date',
        'Invalid Date Range',
        'center',
      );
      return;
    }
    generateReport({
      report_type: ReportType.SUPPORT_TICKET_REPORT,
      from: dayjs(startDate).format(DATE_FORMAT),
      to: dayjs(endDate).format(DATE_FORMAT),
    });
  };

  return (
    <Modal animation={false} centered show={true} onHide={onHide}>
      <div>
        <Modal.Header closeButton>
          <Modal.Title>Export Support Ticket Report</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col>
              <Form.Label>Select Date Range</Form.Label>
              <div className="d-flex">
                <DatePicker
                  selected={startDate}
                  onChange={date => setStartDate(date)}
                  selectsStart
                  startDate={startDate}
                  endDate={endDate}
                  customInput={<Form.Control />}
                  placeholderText="Start Date"
                  dateFormat="yyyy-MM-dd"
                />
                <DatePicker
                  className="ml-2"
                  selected={endDate}
                  onChange={date => setEndDate(date)}
                  selectsEnd
                  startDate={startDate}
                  endDate={endDate}
                  minDate={startDate}
                  customInput={<Form.Control />}
                  placeholderText="End Date"
                  dateFormat="yyyy-MM-dd"
                />
              </div>
            </Col>
          </Row>
          <hr />
          <div>
            <Button onClick={handleExport} size="lg" className="mr-2" disabled={loading}>
              {loading ? <Spinner animation="border" role="status" size="sm" /> : 'Export'}
            </Button>
            <Button size="lg" variant="outline-primary" onClick={onHide}>
              Cancel
            </Button>
          </div>
        </Modal.Body>
      </div>
    </Modal>
  );
}

SupportTicketReportExportModal.propTypes = {
  onHide: PropTypes.func.isRequired,
};

export default SupportTicketReportExportModal;
